
import Toolbar from './components/toolbar'
import Query from './components/query'

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

function install (Vue) {
  Vue.component(Toolbar.name, Toolbar)
  Vue.component(Query.name, Query)
}

export default {
  install,
  Toolbar,
  Query
}



// WEBPACK FOOTER //
// ./src/index.js